import React, { createContext, useState, useEffect, useContext, useMemo, useCallback } from 'react';
import { getUserDetails, getUserProfile } from '../utils/apiServices';

export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const access = localStorage.getItem('access');
    if (access) {
      Promise.all([
        getUserDetails(access),
        getUserProfile(access),
      ]).then(([userData, profileData]) => {
        setUser({ ...userData, token: access });
        setProfile(profileData);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (accessToken) => {
    localStorage.setItem('access', accessToken);
    const [userData, profileData] = await Promise.all([
      getUserDetails(accessToken),
      getUserProfile(accessToken),
    ]);
    setUser({ ...userData, token: accessToken });
    setProfile(profileData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    setUser(null);
    setProfile(null);
  }, []);

  const updateProfile = useCallback((updatedProfile) => {
    setProfile(updatedProfile);
  }, []);

  const value = useMemo(
    () => ({ user, profile, login, logout, loading, updateProfile }),
    [user, profile, login, logout, loading, updateProfile],
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
